module.exports = __webpack_public_path__ + "img/base_patrimoine_industrie.7a9e4c62.svg";